(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header_bak"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-chefs"]) return;
  try {
    
  // swiper
  const mediaQueryList = window.matchMedia('(max-width: 749px)');
  let chefsSwiper = null;
  const initSwiper = () => {
    if (mediaQueryList.matches) {
      chefsSwiper = new Swiper('#js-topChefsSlider', {
        loop: true,
        slidesPerView: 1.2,
        spaceBetween: 20,
        centeredSlides: true,
      });
    } else {
      if (chefsSwiper) {
        chefsSwiper.destroy(false, true);
      }
    }
  };
  mediaQueryList.addEventListener('change', initSwiper);
  initSwiper();

  // modal
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.js-modalOpen').forEach(function (element) {
      element.addEventListener('click', function (event) {
        event.preventDefault();
        const target = this.dataset.modaltarget;
        const modal = document.getElementById(target);
        if (modal) {
          modal.classList.add('is-visible');
        }
      });
    });
    document.querySelectorAll('.js-modalClose').forEach(function (element) {
      element.addEventListener('click', function (event) {
        event.preventDefault();
        document.querySelectorAll('.js-modal').forEach(function (modal) {
          modal.classList.remove('is-visible');
        });
      });
    });
  });
  // 





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-items"]) return;
  try {
    
  document.querySelectorAll('.js-tabToggle').forEach(function (tabToggle) {
    tabToggle.addEventListener('click', function () {
      var tabName = this.dataset.tabName;
      document.querySelectorAll('.js-tabToggle').forEach(function (toggle) {
        toggle.classList.remove('is-active');
      });
      document.querySelectorAll('.js-tabContent').forEach(function (content) {
        content.classList.remove('is-active');
      });
      this.classList.add('is-active');
      document.querySelectorAll('.js-tabContent').forEach(function (tabContent) {
        var tabTarget = tabContent.dataset.tabTarget;
        if (tabName === tabTarget) {
          tabContent.classList.add('is-active');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-journal"]) return;
  try {
    
  const journalSwiperLoop = (document.querySelectorAll('#js-topJournalSlider .top-journal__slide').length >= 3) ? true : false;
  const journalSwiper = new Swiper('#js-topJournalSlider', {
    loop: journalSwiperLoop,
    slidesPerView: 1.2,
    spaceBetween: 20,
    centeredSlides: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      750: {
        centeredSlides: false,
        slidesPerView: 3,
        spaceBetween: 24,
      },
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-mv"]) return;
  try {
    
  const mvSwiper = new Swiper('#js-topMvSlider', {
    loop: true,
    speed: 1000,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    slidesPerView: 1,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    effect: 'fade',
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-partners"]) return;
  try {
    
  const mediaQueryList = window.matchMedia('(max-width: 749px)');
  let partnerSwiper = null;
  const initSwiper = () => {
    if (mediaQueryList.matches) {
      partnerSwiper = new Swiper('#js-topPartnerSlider', {
        loop: true,
        slidesPerView: 1.2,
        spaceBetween: 20,
        centeredSlides: true,
      });
    } else {
      if (partnerSwiper) {
        partnerSwiper.destroy(false, true);
      }
    }
  };
  mediaQueryList.addEventListener('change', initSwiper);
  initSwiper();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-brand"]) return;
  try {
    
  // parallax animation
  let lastScrollY = 0;
  let ticking = false;
  function updateParallax() {
    let scrolled = window.scrollY;
    document.querySelectorAll('.js-parallax').forEach((bg) => {
      let offsetTop = bg.parentElement.offsetTop;
      let speed = 0.5;
      let translateY = (scrolled - offsetTop) * speed;
      bg.style.transform = `translateY(${translateY}px)`;
    });
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    lastScrollY = window.scrollY;
    if (!ticking) {
      requestAnimationFrame(updateParallax);
      ticking = true;
    }
  });

  // scroll animation
  const fadeElements = document.querySelectorAll('.js-anime');
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animated');
        }
      });
    },
    { threshold: 0.2 }
  );
  fadeElements.forEach((element) => observer.observe(element));

  // modal
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.js-modalOpen').forEach(function (element) {
      element.addEventListener('click', function (event) {
        event.preventDefault();
        const target = this.dataset.modaltarget;
        const modal = document.getElementById(target);
        if (modal) {
          modal.classList.add('is-visible');
        }
      });
    });
    document.querySelectorAll('.js-modalClose').forEach(function (element) {
      element.addEventListener('click', function (event) {
        event.preventDefault();
        document.querySelectorAll('.js-modal').forEach(function (modal) {
          modal.classList.remove('is-visible');
        });
      });
    });
  });

  // swiper
  const gallerySwiper = new Swiper('#js-brandGallerySlider', {
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 8,
    centeredSlides: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    autoplay: {
      delay: 5000,
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommended-block"]) return;
  try {
    
  const mediaQueryList = window.matchMedia('(max-width: 749px)');
  let recomSwiper = null;
  const initSwiper = () => {
    if (mediaQueryList.matches) {
      recomSwiper = new Swiper('#js-topRecomSlider', {
        loop: true,
        slidesPerView: 1.2,
        spaceBetween: 20,
        centeredSlides: true,
      });
    } else {
      if (recomSwiper) {
        recomSwiper.destroy(false, true);
      }
    }
  };
  mediaQueryList.addEventListener('change', initSwiper);
  initSwiper();

  } catch(e) { console.error(e); }
})();
})();
